import { DateRangeProvider } from '../../contexts/DateRangeContext';
import { AgentFilterProvider } from '../../contexts/AgentFilterContext';
import { AgentServiceProvider } from '../../contexts/AgentServiceContext';
import { AgentLabelsProvider } from '../../contexts/AgentLabelsContext';
import { copilotService, getAppDisplayName } from '../../services/copilot/copilotService';
import { COPILOT_SCOPE_MODULES } from '../../services/copilot/copilotScopeStore';
import CopilotConnectionGate from './CopilotConnectionGate';
import CopilotScopeSync from './CopilotScopeSync';

export const M365_LABELS = {
  module: 'copilot',
  productName: 'Microsoft 365 Copilot',
  noun: 'App',
  nounPlural: 'Apps',
  pageTitle: 'Conversations',
  pageSubtitle: 'Explore sessions and conversations with Microsoft 365 Copilot',
  dashboardSubtitle: 'Business intelligence, app performance, and security insights for Microsoft 365 Copilot',
  usersPageSubtitle: 'Monitor Microsoft 365 Copilot usage and risk levels by user',
  usersStatHelp: 'Total number of unique users who have interacted with Microsoft 365 Copilot.',
  userSegmentsHelp: 'Users grouped by engagement from interaction volume, applications used, and sessions. Missing execution outcomes do not lower a user\'s segment.',
  interactionEventType: 'copilot_interaction',
  unknownLabel: 'Unknown',
  responseSenderFallback: 'Copilot',
  // Every page filters by App and user on the server (scope_agent / scope_user):
  // the shared filter bar draws the Atlas pickers instead of its own panel and the
  // shared pages skip their row-level re-filtering (see GeminiFilterBar).
  hasAgentFilter: true,
  serverScoped: true,
  // App values are raw gen_ai.application ("IPM.SkypeTeams.Message.Copilot.Outlook");
  // the pickers show the friendly name and keep the raw value as the selection.
  formatAgent: getAppDisplayName,
  licenseCostLabel: 'Microsoft 365 Copilot License Cost ($/user/month)',
  licenseCostHelp: 'Monthly cost per Microsoft 365 Copilot license. Used to calculate potential savings from unused licenses and cost per query.',
  licenseCostSubtitle: 'Per-user monthly Microsoft 365 Copilot license cost',
  settingsPageTitle: 'Microsoft 365 Copilot Settings',
  settingsPageSubtitle: 'Configure ROI calculations and compliance frameworks for Microsoft 365 Copilot. Alerts, notifications, and digests are managed under Notifications and Alert Configuration.',
  routeBase: '/copilot',
  // M365 audit records carry no session outcome, so the shared Conversations
  // page hides its Session Completion card instead of showing an invented
  // rate (audit B10).
  showConversationCompletion: false,
  // Compliance catalogue module for this product. The shared Log Explorer
  // still loads the Gemini Enterprise catalogue (audit A18); it should read
  // this key once that page is changed.
  complianceModule: 'microsoft-copilot',
};

const CopilotLayout = () => (
  <AgentLabelsProvider value={M365_LABELS}>
    <AgentServiceProvider value={copilotService}>
      <DateRangeProvider>
        <AgentFilterProvider storageKey="copilot_filters">
          <CopilotScopeSync module={COPILOT_SCOPE_MODULES.M365} routeBase={M365_LABELS.routeBase} />
          <CopilotConnectionGate />
        </AgentFilterProvider>
      </DateRangeProvider>
    </AgentServiceProvider>
  </AgentLabelsProvider>
);

export default CopilotLayout;
